module.exports = __webpack_public_path__ + "img/spartan-demolition-sitework-04-square.90277f7c.jpg";